export const sqOpenPageList = [
    '/sqmall/collection',
    '/sqmall/collectionDetail/',
    '/channel/my/businessDynamicsDetail/',
    '/sqmall/goodsDetail/',
    '/channel/goodsDetailNew/'
]

export const sqTowerPageList = ['/general', '/distribute']

export const noInSqTowerPageList = [
    '/channel/my/sales/tower/afterSales',
    '/channel/my/bill/unStatementOrder',
    '/channel/my/bill/statementOrder'
]

// 档口绑定状态
export const GATE_VERIFIED = 'VERIFIED' // 审核通过
export const GATE_WAIT_AUDIT = 'WAIT_AUDIT' // 待审核
export const GATE_REFUSED = 'REFUSED' // 审核拒绝
export const GATE_TERMINATION = 'TERMINATION' // 已解绑

export const GATE_STATUS_MAP = {
    [GATE_VERIFIED]: {
        label: '审核通过',
        color: '#22B001',
        type: 'success'
    },
    [GATE_WAIT_AUDIT]: {
        label: '待审核',
        color: '#FA6400',
        type: 'warning'
    },
    [GATE_REFUSED]: {
        label: '审核拒绝',
        color: '#F04852',
        type: 'error'
    },
    [GATE_TERMINATION]: {
        label: '已解绑',
        type: 'default'
    }
}
